import { useCallback } from 'react';
import { useAppDispatch } from '@platform/state/hooks';
import { findModuleSlice } from '@platform/state/modules/moduleSliceRegistry';
import { defaultListViewState, listKeyOf, listStateChanged } from '@platform/state/slices/viewStateSlice';
import { advancedKey, quickFieldsStore } from '../advanced/advancedStore';
import { LANDING_STATE } from './landingState';

/**
 * Скидання стану пункту меню перед відкриттям модуля (прототип v4 openModule): стан пункту `menuItem` типу `rt` стає LANDING_STATE —
 * у зрізі пакета модуля, якщо пакет завантажено, інакше в платформному viewState (як читає useRecordListModel); швидкі поля типу
 * скидаються, умови розширених фільтрів лишаються (вони діють для всього модуля й зберігаються між сесіями).
 */
export function useLandingReset(): (ws: string, moduleKey: string, rt: string, menuItem: string) => void {
  const dispatch = useAppDispatch();
  return useCallback((ws: string, moduleKey: string, rt: string, menuItem: string) => {
    const key = { workspaceId: ws, recordType: rt, menuItem };
    const slice = findModuleSlice(moduleKey);
    if (slice) dispatch(slice.listStateChanged({ key: listKeyOf(key), patch: LANDING_STATE, defaults: defaultListViewState('table') }));
    else dispatch(listStateChanged({ key, patch: LANDING_STATE, defaultView: 'table' }));
    quickFieldsStore.write(advancedKey(ws, rt), null);
  }, [dispatch]);
}
